import type { ProviderKind } from '@hangar/shared';
import type { ProviderAccount } from '@/api/schemas';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { ConnectForm } from './ConnectProviderForm';
import { EditForm } from './EditProviderForm';

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  /** Edit this account's name and slots; absent = connect a new account. */
  editing?: ProviderAccount;
  /** The provider a new account starts with ("Connect Bitrise account"). */
  kind?: ProviderKind;
}

function SheetForm({ editing, kind, onDone }: { editing?: ProviderAccount; kind?: ProviderKind; onDone: () => void }) {
  return editing ? <EditForm key={editing.id} account={editing} onDone={onDone} /> : <ConnectForm initialKind={kind} onDone={onDone} />;
}

/**
 * Connect a build provider account — Expo EAS (name, Expo account, robot token, slots) or Bitrise (name, workspace,
 * personal access token, slots) — or edit one (name, slots). The token goes once to `POST /credentials`
 * (`eas_access_token` / `bitrise_api_token`, stored encrypted, never returned) and the account references the
 * credential id: the console never keeps or shows it. Bitrise is offered once the API builds on it
 * (`me.features.bitrise`); until then it says "Available soon".
 */
export function ProviderAccountSheet({ open, onOpenChange, editing, kind }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" data-testid="provider-account-sheet" className="w-full gap-0 p-0" aria-describedby="provider-account-desc">
        {open ? <SheetForm editing={editing} kind={kind} onDone={() => onOpenChange(false)} /> : null}
      </SheetContent>
    </Sheet>
  );
}
